module.exports = __webpack_public_path__ + "static/media/group--general-cleanliness.797c55c8.svg";